module.exports = __webpack_public_path__ + "img/1388.220cea41.gif";